import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styles from "./SessionInformationComponent.module.scss";

const SessionInformationComponent = (props: { value: string }) => {
    const { value } = props;

    return (
        <div className={styles.mainContainer}>
            <InfoOutlinedIcon className={styles.iconStyle} />
            <div className={styles.textStyle}>{value}</div>
        </div>
    );
};

export default SessionInformationComponent;
